// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PbTk","content":"styles_content__2L2sm"};